<div class="changelog-dialog">
    <div class="content markdown">
        <markdown #markdownElement [src]="'./CHANGELOG.md'"></markdown>
    </div>
    <div class="close-button">
        <button mat-button mat-dialog-close>close</button>
    </div>
</div>
